<!-- Card Header Start-->

<div class="p-4 pb-0">
  <div class="flex justify-between items-center mb-4">
    <h1 class="font-medium text-[18px] leading-6 text-[#15191E] ">Notifications</h1>
    <button class="size-5 rounded-md flex justify-center items-center outline-0 hover:bg-black cursor-pointer group"
      [mat-dialog-close]="true" (click)="cancel()">

      <!-- Gray cross (default) -->
      <img src="./assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden" alt="gray cross"
        height="10" width="10">

      <!-- White cross (on hover) -->
      <img src="./assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block" alt="white cross"
        height="10" width="10">
    </button>
  </div>


  <div class="flex justify-between items-center">
    <ul class="text-sm leading-5 font-medium text-[#9F9FA9] gap-7 flex">
      <li class="pb-3 cursor-pointer border-b-2 border-[#1379F0]">All</li>
      <li class="pb-3 cursor-pointer">Inbox</li>
      <li class="pb-3 cursor-pointer">Team</li>
      <li class="pb-3 cursor-pointer">Following</li>
    </ul>
    <span class="p-1 hover:bg-gray-200 rounded-md cursor-pointer">
      <img src="./assets/images/icons/global/setting-black.svg" alt="">
    </span>
  </div>
</div>
<div class="border-b border-[#EBEBEE]"></div>
<!-- Card Header End-->


<mat-dialog-content class="mat-typography !pt-0 !px-0">
  <div class="px-6 py-3 border-b border-[#EBEBEE]" *ngFor="let notify of this.notifications?.data">

      <div class="flex justify-start items-start gap-2.5" (click)="markAsRead(notify?.id)">
        <div class="relative">
          <app-avatar [userList]="[{displayName: notify?.user?.firstName + ' ' + notify?.user?.lastName , pic: notify?.user?.pic}]" size="2xl" [showTooltip]="false"></app-avatar>
          <span *ngIf="!isRead(notify?.isRead)" class="size-2.5 bg-[#00A63E] absolute top-7 rounded-full right-0 border border-white z-50"></span>
        </div>
        <div class="flex-1">
          <p class="font-bold text-md leading-5 text-[#09090B]">{{notify?.user?.firstName + ' ' + notify?.user?.lastName}}
          </p>
            <p class="font-medium text-md text-[#09090B]">{{notify?.message}}</p>
          <div class="flex justify-items-start items-center gap-1.5">
            <p class="text-[#9F9FA9] font-medium text-xs leading-4">{{getDate(notify.createdOn) | timeAgo}}</p>
            <div class="size-1 bg-[#09090B4D] rounded-full"></div>
            <p class="text-[#9F9FA9] font-medium text-xs leading-4">{{getDate(notify.createdOn) | date}}</p>
          </div>

        </div>
      </div>


  </div>

  <div class="px-6 py-5 border-b border-[#EBEBEE] hidden">
    <div class="flex justify-start items-start gap-2.5">
      <div class="relative">
        <app-avatar [userList]="[{displayName: 'Leslie Alexander', pic: null}]" size="2xl"></app-avatar>
        <span class="size-2.5 bg-[#00A63E] absolute top-7 rounded-full right-0 border border-white z-50"></span>
      </div>
      <div class="flex-1">
        <p class="font-semibold text-md leading-5 text-[#09090B] mb-1.5">Leslie Alexander
          <span class="ms-0.5 font-medium">added new tags to<span class="text-[#1379F0] mx-0.5">Web Redesign 2024</span></span>
        </p>
        <div class="flex justify-items-start items-center gap-1.5 mb-5">
          <p class="text-[#9F9FA9] font-medium text-xs leading-4">53 mins ago</p>
          <div class="size-1 bg-[#09090B4D] rounded-full"></div>
          <p class="text-[#9F9FA9] font-medium text-xs leading-4">ACME</p>
        </div>
        <div class="flex justify-items-start items-start gap-2.5">
          <span class="badge badge-outline badge-primary !inline-flex items-center justify-center gap-1.5">
            <span>Client-Request</span>
          </span>
          <span class="badge badge-outline badge-success !inline-flex items-center justify-center gap-1.5">
            <span>Figma</span>
          </span>
          <span class="badge badge-outline badge-danger !inline-flex items-center justify-center gap-1.5">
            <span>Redesign</span>
          </span>
        </div>

      </div>
    </div>
  </div>

  <div class="px-6 py-5 border-b border-[#EBEBEE] hidden">
      <div class="flex justify-start items-start gap-2.5">
        <div class="relative">
          <app-avatar [userList]="[{displayName: 'Guy Hawkins', pic: null}]" size="2xl"></app-avatar>
          <span class="size-2.5 bg-[#00A63E] absolute top-7 rounded-full right-0 border border-white z-50"></span>
        </div>
        <div class="flex-1">
          <p class="font-semibold text-md leading-5 text-[#09090B] mb-1.5">Guy Hawkins
            <span class="ms-0.5 font-medium">requested access to<span class="text-[#1379F0] mx-0.5">AirSpace</span>project</span>
          </p>
          <div class="flex justify-items-start items-center gap-1.5 mb-5">
            <p class="text-[#9F9FA9] font-medium text-xs leading-4">14 hours ago</p>
            <div class="size-1 bg-[#09090B4D] rounded-full"></div>
            <p class="text-[#9F9FA9] font-medium text-xs leading-4">Dev Team</p>
          </div>
          <div class="flex gap-2.5">
            <bk-button variant="secondary" label="Decline" size="sm" buttonClass="text-[#18181B] border-[#E4E4E7] !py-[5px]"></bk-button>
            <bk-button variant="primary" label="Accept" size="sm" buttonClass="text-white bg-[#141414] !py-[5px]"></bk-button>
          </div>
        </div>
      </div>
  </div>

  <div class="px-6 py-5 border-b border-[#EBEBEE] hidden">
    <div class="flex justify-start items-start gap-2.5">
      <div class="relative">
        <app-avatar [userList]="[{displayName: 'Jane Tane', pic: null}]" size="2xl"></app-avatar>
        <span class="size-2.5 bg-[#00A63E] absolute top-7 rounded-full right-0 border border-white z-50"></span>
      </div>
      <div class="flex-1">
        <p class="font-semibold text-md leading-5 text-[#09090B] mb-1.5">Jane Perez
          <span class="ms-0.5 font-medium">invites you to review a file.</span>
        </p>
        <div class="flex justify-items-start items-center gap-1.5 mb-5">
          <p class="text-[#9F9FA9] font-medium text-xs leading-4">3 hours ago</p>
          <div class="size-1 bg-[#09090B4D] rounded-full"></div>
          <p class="text-[#9F9FA9] font-medium text-xs leading-4">742kb</p>
        </div>
        <div class="border-[#EBEBEE] bg-[#F3F4F6B2] rounded-lg p-3 flex justify-items-start items-center gap-1.5">
          <img src="../../../assets/images/icons/global/pdf.svg" alt="">
          <p class="text-[#4A5565] font-medium text-xs leading-4">Launch_nov24.pptx <span class="ms-2 text-[#9F9FA9]">Edited 39 mins ago</span></p>
        </div>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="!p-5 !border-t !border-[#EBEBEE] gap-4">
  <!--  <div class="flex">-->

  <div class="flex-1">
    <bk-button variant="secondary" 
    label="Load More" 
    size="sm"
    buttonClass="text-[#18181B] bg-white w-full border-[#E4E4E7] shrink-0 !py-[5px] rounded-md" 
    (clicked)="loadMoreNotifications()" 
    [loading]="nextLoading" 
    [disabled]="loading">
    </bk-button>
  </div>
  <div class="flex-1">
    <bk-button 
      variant="secondary"
      label="Mark all as read"
      size="sm"
      buttonClass="text-[#18181B] bg-white w-full border-[#E4E4E7] shrink-0 !py-[5px] rounded-md" 
      (clicked)="markAllAsRead()" 
      [loading]="loading" 
      [disabled]="nextLoading">
    </bk-button>
  </div>
  <!--  </div>-->
</mat-dialog-actions>
